<template>
  <div id="OrganizationFulfillment">
    <div class="vx-col w-full mb-base">
      <vx-card collapse-action
               title="Fulfillment Provider"
               title-color="primary"
               subtitle="Select Fulfillment Provider for your Store">

        <div class="vx-row mb-6 w-full md:w-2/3 lg:w-2/3">
          <div class="vx-col w-full md:w-2/3 lg:w-3/5" v-if="has_non_selected_providers">
            <v-select label="name" :options="non_selected_providers" v-model="selected_fulfillment" />
          </div>
          <div class="vx-col w-full md:w-2/3 lg:w-2/5 mt-6 md:mt-0">
            <vs-button color="success" type="filled" @click="addFulfillment" v-if="!has_apikey_fields && has_chosen_provider">Add Provider</vs-button>
          </div>
        </div>

        <div :key="idx" v-for="(field, idx) in selected_fulfillment.api_key_fields">
          <div class="vx-row mb-6 w-full md:w-2/3 lg:w-2/3">
            <div class="vx-col w-full md:w-1/5 lg:w-2/3">
              <span>{{field.label}}</span>
            </div>
            <div class="vx-col w-full md:w-2/5 lg:w-2/5" v-if="field.type === 'text'">
              <vs-input :placeholder="field.placeholder" class="w-full" v-model="field.value" v-validate="'required'"/>
            </div>
            <div class="vx-col w-full md:w-2/5 lg:w-2/5" v-if="field.type === 'options'">
              <v-select label="label" :options="get_options(field.option_id)" v-model="field.value" />
            </div>
            <div class="vx-col w-full mt-6 md:mt-0 md:w-2/5 lg:w-2/5" v-if="is_last_field(idx)">
              <vs-button color="success" type="filled" @click="addFulfillment" >Add Provider</vs-button>
            </div>
          </div>
        </div>

        <vs-table :data="selected_providers">

          <template slot="thead">
            <vs-th>Fulfillment Type</vs-th>
            <vs-th>Api Key</vs-th>
            <vs-th>Status</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in selected_providers">

              <vs-td :data="tr.provider_name">
                {{ tr.provider_name }}
              </vs-td>

              <vs-td :data="tr.api_key_values" v-if="tr.api_key_values.length > 0">
                {{ tr.apikey_display }} <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-6" @click.stop="editApiKey(tr)" />
              </vs-td>

              <vs-td :data="tr.api_key_values" v-else>
                {{ tr.api_key_values }}
              </vs-td>

              <vs-td :data="tr.status">
                <vs-switch v-model="tr.status" />
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteFulfillment(tr)" />
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveChanges">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">Reset</vs-button>
        </div>

      </vx-card>
    </div>

    <template>
      <vs-popup title="API Key Settings" :active.sync="popupApiKey">
        <div class="vx-col w-full mb-base" :key="idx" v-for="(field, idx) in popupProvider.api_key_values">
          <div class="vx-row w-full" v-if="field.type === 'text'">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{field.label}}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input :label-placeholder="field.placeholder" class="w-full" v-model="field.value" v-validate="'required'"/>
            </div>
          </div>
          <div class="vx-row w-full" v-if="field.type === 'options'">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{field.label}}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select label="label" :options="get_options(field.option_id)" v-model="field.value" />
            </div>
          </div>
        </div>

        <div class="vx-col w-full mb-base">
          <div class="vx-row mb-0">
            <div class="vx-col sm:w-1/3 w-full">
              <span>&nbsp;</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="vx-col ml-auto mr-auto">
                <vs-button class="mr-3 mb-2" size="large" @click.stop="saveApiKey">Save</vs-button>
                <vs-button color="warning" type="border" class="mr-3 mb-2" size="large" @click.stop="cancelApiKey">Cancel</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import location from '@/services/locationService';


const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  }
}

export default {
  components: {
    'v-select': vSelect,
  },

  data () {
    return {
      selected_fulfillment: {
        id: 0,
        name: '',
        is_require_api_key: 0,
        api_key_fields: []
      },

      original_providers: [],
      selected_providers: [],
      providers: [],
      popupApiKey: false,
      popupProvider: {},
    }
  },

  methods: {

    addFulfillment() {
      let new_fulfillment = {
        "id": 0,
        "organization_id": this.$store.state.user.current_organization,
        "fullfillment_provider_id": this.selected_fulfillment.id,
        "api_key_values": this.selected_fulfillment.api_key_fields||'',
        "status": 1,
        "provider_name": this.selected_fulfillment.name,
        "is_require_api_key": this.selected_fulfillment.is_require_api_key,
        "api_key_fields": this.selected_fulfillment.api_key_fields,
        "has_shipping_rate": this.selected_fulfillment.has_shipping_rate
      }

      this.selected_providers.push(new_fulfillment);
      this.selected_fulfillment = this.blankFulfillment();
    },

    blankFulfillment() {
      return {
        id: 0,
        name: '',
        is_require_api: false,
        api_key_fields: []
      } 
    },

    deleteFulfillment(fulfillment) {
      this.selected_providers = this.selected_providers.filter((x) => x.fullfillment_provider_id !== fulfillment.fullfillment_provider_id);
    },

    async saveChanges() {
      this.$store.commit('fulfillment/SET_ORGANIZATION_PROVIDERS', this.selected_providers);
      await this.$store.dispatch('fulfillment/bulkUpdate');
      this.original_providers = JSON.parse(JSON.stringify(this.$store.state.fulfillment.organization_providers));
      this.$vs.notify(notifs.success("Fulfilment Providers successfully updated."))
    },

    reset() {
      this.selected_providers = this.original_providers;
      this.selected_fulfillment = this.blankFulfillment();
    },

    is_last_field(idx) {
      return idx === this.selected_fulfillment.api_key_fields.length - 1;
    },

    get_options(option_id) {
      return location[option_id] || [];
    },

    editApiKey(data) {
      this.popupProvider = data;
      this.popupApiKey = true;
    },

    saveApiKey() {
      for (let field of this.popupProvider.api_key_values) {
        if (field.name === 'apikey' || field.name === 'api_key') {
          this.popupProvider.apikey_display = field.value;
        }
      }

      this.popupApiKey = false;
    },

    cancelApiKey() {
      this.popupApiKey = false;
    },

  },

  computed: {
    non_selected_providers () {
      let used_id = this.selected_providers.map((x) => x.fullfillment_provider_id);
      return this.providers.filter(x => used_id.indexOf(x.id) < 0);
    },

    is_easyparcel () {
      let name = this.selected_fulfillment.name || '';
      name = name.toLowerCase();
      return name.indexOf('easyparcel') > -1;
    },

    has_apikey_fields () {
      return !_.isEmpty(this.selected_fulfillment.api_key_fields );
    },

    has_chosen_provider() {
      return this.selected_fulfillment.id > 0;
    },

    has_non_selected_providers () {
      console.log('has non')
      console.log(!_.isEmpty(this.non_selected_providers));
      return !_.isEmpty(this.non_selected_providers);
    },
  },

  async mounted () {
    let result = await Promise.all([
      this.$store.dispatch('fulfillment/getCouriers'),
      this.$store.dispatch('fulfillment/getOrganizationProvider', this.$store.state.user.current_organization),
      this.$store.dispatch('fulfillment/getProviders')
    ]).then((res)=> {
      this.original_providers = JSON.parse(JSON.stringify(this.$store.state.fulfillment.organization_providers || []));
      this.selected_providers = JSON.parse(JSON.stringify(this.original_providers || []));
      this.providers = JSON.parse(JSON.stringify(this.$store.state.fulfillment.providers || []));
    }).catch((e) => {
        console.log(e);
      })
  }
}
</script>

<style lang="scss">
#OrganizationFulfillment {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.con-vs-popup .vs-popup {
  width: 600px !important;
}

</style>
